/**
 * Price approval/retry handlers.
 */
import { createLogger } from '../../../shared/logger.js';
import { handlePriceReview } from '../../modules/priceReview';
import { openCheckoutModal, showToast, dismissToast } from '../../modules/ui';
import { applyRemoteSnapshot, mapRemoteDocument } from '../../modules/lotOperations';
import type { TableHandlerDeps } from './types';

const log = createLogger('portal:tableHandlers:price');

export async function handlePriceApproval(
  id: string,
  e: Event,
  deps: TableHandlerDeps
): Promise<void> {
  const { state, render, ensureAccessToken, applyModeBanner, DEBUG } = deps;

  const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
  if (!lot) return;

  e.preventDefault();

  try {
    await handlePriceReview(
      lot,
      'price-ack',
      state,
      render,
      showToast,
      dismissToast,
      openCheckoutModal,
      applyRemoteSnapshot,
      applyModeBanner,
      ensureAccessToken,
      mapRemoteDocument,
      DEBUG
    );
  } catch (err) {
    log.error('Price approval failed:', err);
  }
}

export async function handlePriceRetry(
  id: string,
  e: Event,
  deps: TableHandlerDeps
): Promise<void> {
  const { state, render, ensureAccessToken, applyModeBanner, DEBUG } = deps;

  const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
  if (!lot) return;

  e.preventDefault();

  try {
    await handlePriceReview(
      lot,
      'price-retry',
      state,
      render,
      showToast,
      dismissToast,
      openCheckoutModal,
      applyRemoteSnapshot,
      applyModeBanner,
      ensureAccessToken,
      mapRemoteDocument,
      DEBUG
    );
  } catch (err) {
    log.error('Price review failed:', err);
  }
}
